export default function checkIfCanList({ next, store }) {
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_roles_list_company') || scopes.includes('system_roles_list_all')) {
    return next();
  }
  return next({
    name: 'settings',
  });
}
